import * as React from 'react';
import {Field, FieldProps} from 'formik';
import {withTranslation, WithTranslation} from 'react-i18next';

import ValidationError from '@src/components/Form/ValidationError';

import * as styles from './radioOptions.module.scss';

import type {Namespace} from 'i18next';

interface RadioOptionsProps extends WithTranslation<'EnrollForm'> {
  name: string;
  display: 'block' | 'inline';
  required: boolean;
  options: string[];
  inverse?: boolean;
  useOptionAsKey?: boolean;
  updateFormState?: (evt: React.MouseEvent<HTMLInputElement>) => void;
}

export const UntranslatedRadioOptions = ({
  name,
  display,
  required,
  options,
  inverse,
  useOptionAsKey,
  updateFormState,
  t,
}: RadioOptionsProps) => {
  // @ts-ignore
  const translatedOptions = t(`${name}.options`).split('|');

  return (
    <div>
      <div className={`${styles.content} ${inverse ? styles.inverse : ''}`}>
        <fieldset className={styles[`fieldset-${display}`]}>
          <legend>
            {/* @ts-ignore */}
            {t(`${name}.label`)}{' '}
            {required && (
              <span className={styles.required}>{t('required')}</span>
            )}
          </legend>
          <ul className={styles.radioList}>
            {options.map((o, i) => {
              const id = `${name}${i}`;

              return (
                <li key={i} className={styles[display]}>
                  <Field name={name}>
                    {({field: {value, onChange, onBlur}}: FieldProps) => (
                      <div>
                        <input
                          name={name}
                          id={id}
                          type="radio"
                          value={o}
                          checked={value === o}
                          onChange={onChange}
                          onBlur={onBlur}
                          className={styles.radio}
                          onClick={updateFormState}
                          aria-checked={value === o}
                        />
                        <label htmlFor={id} className={styles.checkLabel}>
                          {useOptionAsKey
                            ? t(`${name}.${o}`)
                            : translatedOptions[i]}
                        </label>
                        <div className={styles.check} />
                      </div>
                    )}
                  </Field>
                </li>
              );
            })}
          </ul>
          <ValidationError name={name} inverse={inverse} />
        </fieldset>
      </div>
    </div>
  );
};

export default withTranslation('EnrollForm')(UntranslatedRadioOptions);

export const translateRadioOptions = (translationFile: Namespace) =>
  withTranslation(translationFile)(UntranslatedRadioOptions);
